import { configureStore } from '@reduxjs/toolkit';
import comingFromCreateToTradeReducer from './ephemeralCrypto';
import ephemeralCryptoReducers from './ephemeralCrypto';
import currentUserDataReducer from './ephemeralUserData';
import bitcoinPriceDataReducer from './ephemeralBitcoinPrice';
import animationControlReducer from './animationControl';

const store = configureStore({
  reducer: {
    ...currentUserDataReducer,
    ...ephemeralCryptoReducers,
    ...bitcoinPriceDataReducer,
    ...animationControlReducer,
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

export default store;